module.exports = __webpack_public_path__ + "static/media/hamburger.b5098bdc.png";